// @flow

export type Payload = {
  iss?: string,
  exp?: number,
  iat?: number,
  jti?: string,
  agent?: string,
};

const decodePayload = (token: string): Payload => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return {};
  }
};

export const isValid = (token: string): boolean => {
  const payload = decodePayload(token);

  if (payload.exp === undefined) {
    return false;
  }

  if (payload.exp * 1000 < Date.now()) {
    return false;
  }
  return true;
};
